<script type="text/javascript">
  export default {
    props: ['type', 'pc', 'website'],
    data() {
      return {
        default_content: {
          type: 'my-profile',
          title: 'My Profile',
          active: 1,
          image: '',
          color: 'gray-100',
          opacity: '',
          pad_t: '5',
          pad_r: '0',
          pad_b: '5',
          pad_l: '0',
          icon: '',
          icon_color: 'revinre',
          h2: '',
          h2_color: '',
          h2_desc: '',
          h2_desc_color: '',
          pre_btn: [],
          post_btn: [],
        },
        dsbl_btn: false,

        timezones: [
          'America/New_York',
          'America/Chicago',
          'America/Denver',
          'America/Phoenix',
          'America/Los_Angeles',
          'America/Anchorage',
          'America/Adak',
          'Pacific/Honolulu',
        ],
        states: [
          {value: 'AL', name: 'Alabama'},
          {value: 'AK', name: 'Alaska'},
          {value: 'AZ', name: 'Arizona'},
          {value: 'AR', name: 'Arkansas'},
          {value: 'CA', name: 'California'},
          {value: 'CO', name: 'Colorado'},
          {value: 'CT', name: 'Connecticut'},
          {value: 'DE', name: 'Delaware'},
          {value: 'DC', name: 'District Of Columbia'},
          {value: 'FL', name: 'Florida'},
          {value: 'GA', name: 'Georgia'},
          {value: 'HI', name: 'Hawaii'},
          {value: 'ID', name: 'Idaho'},
          {value: 'IL', name: 'Illinois'},
          {value: 'IN', name: 'Indiana'},
          {value: 'IA', name: 'Iowa'},
          {value: 'KS', name: 'Kansas'},
          {value: 'KY', name: 'Kentucky'},
          {value: 'LA', name: 'Louisiana'},
          {value: 'ME', name: 'Maine'},
          {value: 'MD', name: 'Maryland'},
          {value: 'MA', name: 'Massachusetts'},
          {value: 'MI', name: 'Michigan'},
          {value: 'MN', name: 'Minnesota'},
          {value: 'MS', name: 'Mississippi'},
          {value: 'MO', name: 'Missouri'},
          {value: 'MT', name: 'Montana'},
          {value: 'NE', name: 'Nebraska'},
          {value: 'NV', name: 'Nevada'},
          {value: 'NH', name: 'New Hampshire'},
          {value: 'NJ', name: 'New Jersey'},
          {value: 'NM', name: 'New Mexico'},
          {value: 'NY', name: 'New York'},
          {value: 'NC', name: 'North Carolina'},
          {value: 'ND', name: 'North Dakota'},
          {value: 'OH', name: 'Ohio'},
          {value: 'OK', name: 'Oklahoma'},
          {value: 'OR', name: 'Oregon'},
          {value: 'PA', name: 'Pennsylvania'},
          {value: 'RI', name: 'Rhode Island'},
          {value: 'SC', name: 'South Carolina'},
          {value: 'SD', name: 'South Dakota'},
          {value: 'TN', name: 'Tennessee'},
          {value: 'TX', name: 'Texas'},
          {value: 'UT', name: 'Utah'},
          {value: 'VT', name: 'Vermont'},
          {value: 'VA', name: 'Virginia'},
          {value: 'WA', name: 'Washington'},
          {value: 'WV', name: 'West Virginia'},
          {value: 'WI', name: 'Wisconsin'},
          {value: 'WY', name: 'Wyoming'},
        ],
        referral_types: [
          {value: 'phone call', name: 'Phone Call'},
          {value: 'text message', name: 'Text Message'},
          {value: 'television ad', name: 'Television Ad'},
          {value: 'radio ad', name: 'Radio Ad'},
          {value: 'internet ad', name: 'Internet Ad'},
          {value: 'facebook', name: 'Facebook'},
          {value: 'instagram', name: 'Instagram'},
          {value: 'event', name: 'Event'},
          {value: 'mail brochure', name: 'Mail - Brochure'},
          {value: 'mail postcard', name: 'Mail - Postcard'},
          {value: 'referral', name: 'Referral from another client'},
          {value: 'repeat client', name: 'Repeat Client'},
        ],

        active_tab: 'profile',

        profile_form: {
          name: '',
          phone: '',
          timezone: '',
          referred_by: '',
          referred_name: '',
          Address: '',
          City: '',
          StateOrProvince: '',
          PostalCode: '',
          MailingAddress: '',
          MailingCity: '',
          MailingStateOrProvince: '',
          MailingPostalCode: '',
          BillingAddress: '',
          BillingCity: '',
          BillingStateOrProvince: '',
          BillingPostalCode: '',
        },

        password_form: {
          currentpassword: '',
          newpassword: '',
          newpassword_confirmation: '',
        },

        search: '',
        loading: true,
        results: [],
        pagination: {},
        filters: {
          paginate: 3,
          page: 1,
          total: 0,
          selects: [
            'id',
            'StandardStatus',
            'user_id',
            'Address',
            'City',
            'StateOrProvince',
            'PostalCode',
            'images',
            'ListingContractDate',
            'ListPrice',
            'Longitude',
            'Latitude',
            'thumbnail',
          ],
        },
      }
    },
    computed: {
      computedResults() {
        console.log('computedResults');
        var results = [];

        for(var i in this.results) {
          if((!this.search || JSON.stringify(this.results[i]).toLowerCase().includes(this.search.toLowerCase()))) { results.push(this.results[i]); }
        }
        return results;
      },
    },
    created() {
      if(this.pc && this.pc.init == 'Yes') { for(var i in this.default_content) { this.pc[i] = this.default_content[i]; } this.pc.init = ''; }
      if(!this.pc.pre_btn) { this.pc.pre_btn = []; this.$forceUpdate(); }
      if(!this.pc.post_btn) { this.pc.post_btn = []; this.$forceUpdate(); }

      if(this.type != 'editor') {
        this.profile_form.name = this.user.name;
        this.profile_form.phone = this.user.phone;
        this.profile_form.timezone = this.user.timezone;
        this.profile_form.referred_by = this.user.referred_by;
        this.profile_form.referred_name = this.user.referred_name;
        this.profile_form.Address = this.user.Address;
        this.profile_form.City = this.user.City;
        this.profile_form.StateOrProvince = this.user.StateOrProvince;
        this.profile_form.PostalCode = this.user.PostalCode;
        this.profile_form.MailingAddress = this.user.MailingAddress;
        this.profile_form.MailingCity = this.user.MailingCity;
        this.profile_form.MailingStateOrProvince = this.user.MailingStateOrProvince;
        this.profile_form.MailingPostalCode = this.user.MailingPostalCode;
        this.profile_form.BillingAddress = this.user.BillingAddress;
        this.profile_form.BillingCity = this.user.BillingCity;
        this.profile_form.BillingStateOrProvince = this.user.BillingStateOrProvince;
        this.profile_form.BillingPostalCode = this.user.BillingPostalCode;
        this.fetch_history();
      }
    },
    methods: {
      fetch_history() {
        this.loading = true;
        this.filters.page = this.pagination.current_page;
        this.$http.get('/listings/fetchclient', {params: this.filters}).then(res => {
          // console.log(res);
          this.results = res.data.data;
          this.pagination = res.data;
          this.filters.total = res.data.total;
          this.loading = false;
        }).catch(res => {
          this.loading = false;
          this.$noty.warning("There was an error loading the required data. Please try again and contact support if the problem persists.");
        });
      },
      update_profile() {
        this.dsbl_btn = true;
        this.$http.post('/users/updateprofile', this.profile_form).then(res => {
          // console.log(res);
          this.user.name = this.profile_form.name;
          this.user.phone = this.profile_form.phone;
          this.user.timezone = this.profile_form.timezone;
          this.user.referred_by = this.profile_form.referred_by;
          this.user.referred_name = this.profile_form.referred_name;
          this.user.Address = this.profile_form.Address;
          this.user.City = this.profile_form.City;
          this.user.StateOrProvince = this.profile_form.StateOrProvince;
          this.user.PostalCode = this.profile_form.PostalCode;
          this.user.MailingAddress = this.profile_form.MailingAddress;
          this.user.MailingCity = this.profile_form.MailingCity;
          this.user.MailingStateOrProvince = this.profile_form.MailingStateOrProvince;
          this.user.MailingPostalCode = this.profile_form.MailingPostalCode;
          this.user.BillingAddress = this.profile_form.BillingAddress;
          this.user.BillingCity = this.profile_form.BillingCity;
          this.user.BillingStateOrProvince = this.profile_form.BillingStateOrProvince;
          this.user.BillingPostalCode = this.profile_form.BillingPostalCode;
          this.$noty.success("Changes have been saved.");
          this.dsbl_btn = false;
        }).catch(res => {
          // this.popupErrors(res);
          this.$noty.warning("There was an error loading the required data. Please try again and contact support if the problem persists.");
          this.dsbl_btn = false;
        });
      },
      update_password() {
        this.dsbl_btn = true;
        this.$http.post('/users/updatepassword', this.profile_form).then(res => {
          // console.log(res);
          this.$noty.success("Changes have been saved.");
          this.dsbl_btn = false;
        }).catch(res => {
          // this.popupErrors(res);
          this.$noty.warning("There was an error loading the required data. Please try again and contact support if the problem persists.");
          this.dsbl_btn = false;
        });
      },
    }
  }
</script>

<template>
  <section>

    <div v-if="type == 'editor'">
      <div class="p-3">
        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.active" Title="Active :" :Options="[{name:'Yes',value:1},{name:'No',value:0}]" v-tippy content="Display this section on the live website?"></w-field>
          </div>
        </div>
        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Section background and padding :</h6>
        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="String" v-model="pc.image" Title="Background image URL :"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" Title="Background color :" :Options="theme_colors" v-model="pc.color"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="Number" v-model="pc.opacity" Min="0" Max="10" Title="Background color opacity :" v-tippy content="Background color transparency (0 through 10)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.pad_t" Min="0" Max="20" Title="Top padding :" v-tippy content="Padding for the top of the section (0 through 20)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.pad_r" Min="0" Max="20" Title="Right padding :" v-tippy content="Padding for the right of the section (0 through 20)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.pad_b" Min="0" Max="20" Title="Bottom padding :" v-tippy content="Padding for the bottom of the section (0 through 20)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.pad_l" Min="0" Max="20" Title="Left padding :" v-tippy content="Padding for the left of the section (0 through 20)"></w-field>
          </div>
        </div>
        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Section H2 title :</h6>
        <div class="row">
          <div class="col-sm-6">
            <w-field SimpleDataType="String" v-model="pc.icon" Title="Section icon :" v-tippy content="Section icon"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String List, Single" v-model="pc.icon_color" Title="Section icon color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String" v-model="pc.h2" Title="H2 title :" v-tippy content="Section title"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String List, Single" v-model="pc.h2_color" Title="H2 title color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="Textarea" v-model="pc.h2_desc" Title="H2 description :" v-tippy content="Section description appearing below the section title"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String List, Single" v-model="pc.h2_desc_color" Title="H2 description color : " :Options="theme_colors"></w-field>
          </div>
        </div>

        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Top buttons :</h6>
        <div class="form-group">
          <draggable handle=".handle" v-bind="{animation: 200}" v-model="pc.pre_btn">
            <transition-group tag="div">
              <div v-for="(btn, btn_i) in pc.pre_btn" :key="'f1'+btn_i">
                <div class="row m-0 align-items-end">
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.pre_icon" Title="Pre icon :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.text" Title="Text :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.post_icon" Title="Post icon :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String List, Single" v-model="btn.color" Title="Color : " :Options="theme_colors"></w-field>
                  </div>
                  <div class="col p-0">
                    <w-field SimpleDataType="String" v-model="btn.url" Title="URL :"></w-field>
                  </div>
                  <div class="_w-40 pb-2">
                    <button class="btn btn-white" type="button" v-tippy content="Delete" @click="pc.pre_btn.splice(btn_i, 1); $forceUpdate()"><Icon icon="ri:delete-bin-line"></Icon></button>
                  </div>
                  <div class="_w-40 pb-2">
                    <button class="btn btn-white handle" type="button" v-tippy content="Drag to arrange"><Icon icon="ri:drag-move-2-fill"></Icon></button>
                  </div>
                </div>
              </div>
            </transition-group>
          </draggable>
          <button class="btn btn-sm btn-primary" type="button" @click="pc.pre_btn.push({color: '', pre_icon: '', text: '', post_icon: '', url: ''}); $forceUpdate()"><Icon icon="ri:add-line" height="18"></Icon> Add button</button>
        </div>

        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Testimonials :</h6>
        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.test_color" Title="Background color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.test_name_color" Title="Name color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.test_text_color" Title="Text color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.test_sub_text_color" Title="Sub text color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.test_star_color" Title="Star color : " :Options="theme_colors"></w-field>
          </div>
        </div>

        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Bottom buttons :</h6>
        <div class="form-group">
          <draggable handle=".handle" v-bind="{animation: 200}" v-model="pc.post_btn">
            <transition-group tag="div">
              <div v-for="(btn, btn_i) in pc.post_btn" :key="'f2'+btn_i">
                <div class="row m-0 align-items-end">
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.pre_icon" Title="Pre icon :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.text" Title="Text :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.post_icon" Title="Post icon :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String List, Single" v-model="btn.color" Title="Color : " :Options="theme_colors"></w-field>
                  </div>
                  <div class="col p-0">
                    <w-field SimpleDataType="String" v-model="btn.url" Title="URL :"></w-field>
                  </div>
                  <div class="_w-40 pb-2">
                    <button class="btn btn-white" type="button" v-tippy content="Delete" @click="pc.post_btn.splice(btn_i, 1); $forceUpdate()"><Icon icon="ri:delete-bin-line"></Icon></button>
                  </div>
                  <div class="_w-40 pb-2">
                    <button class="btn btn-white handle" type="button" v-tippy content="Drag to arrange"><Icon icon="ri:drag-move-2-fill"></Icon></button>
                  </div>
                </div>
              </div>
            </transition-group>
          </draggable>
          <button class="btn btn-sm btn-primary" type="button" @click="pc.post_btn.push({color: '', pre_icon: '', text: '', post_icon: '', url: ''}); $forceUpdate()"><Icon icon="ri:add-line" height="18"></Icon> Add button</button>
        </div>

      </div>
    </div>

    <div v-else class="container-fluid">
      <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 _z-n1 _bg-repeat-none _bg-size-cover _bg-position-center" :style="'background-image: url('+(pc['image'] ? fullurlencode(pc['image']) : '')+')'"></div>
      <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 _z-n1" :class="'bg-'+pc['color']+' _o-'+pc['opacity']"></div>
      <div class="container-fluid m_py-35" :class="'pt-'+pc['pad_t']+' pr-'+pc['pad_r']+' pb-'+pc['pad_b']+' pl-'+pc['pad_l']">

        <div class="text-center _w-m-900 mx-auto mb-5">
          <Icon v-if="pc['icon']" :icon="pc['icon']" height="45" class="mb-2" :class="'text-'+pc['icon_color']"></Icon>
          <h2 v-if="pc['h2']" class="mb-3" :class="'text-'+pc['h2_color']" data-aos="fade-zoom-in">{{pc['h2']}}</h2>
          <p v-if="pc['h2_desc']" :class="'text-'+pc['h2_desc_color']" data-aos="fade-zoom-in">{{pc['h2_desc']}}</p>
        </div>

        <div v-if="pc['pre_btn'] && pc['pre_btn'].length" class="text-center mb-5">
          <a v-for="(btn, btn_i) in pc['pre_btn']" :key="btn_i" v-if="btn['text'] || btn['pre_icon'] || btn['post_icon']" class="btn btn-lg mb-3 mx-3" :class="'btn-'+btn['color']" :href="btn['url']" target="_blank">
            <Icon v-if="btn['pre_icon']" :icon="btn['pre_icon']" height="20"></Icon>
            <span v-if="btn['pre_icon'] && btn['text']" class="border-left mx-3"></span>
            {{ btn['text'] }}
            <span v-if="btn['post_icon'] && btn['text']" class="border-left mx-3"></span>
            <Icon v-if="btn['post_icon']" :icon="btn['post_icon']" height="20"></Icon>
          </a>
        </div>

        <div class="row">
          <div class="col-sm-3">
            <ul class="nav flex-column rounded bg-dark text-white">
              <li class="nav-item p-3 m-0 rounded-top"><Icon class="mr-2" icon="ri:menu-line" /> Navigation</li>
            </ul>
            <ul class="nav flex-column rounded bg-white navtab-carrot">
              <li class="nav-item">
                <a class="nav-link py-3 border-top border-light text-black" :class="active_tab == 'profile' ? 'active' : ''" @click="active_tab = 'profile'"><Icon icon="ri:map-pin-user-line" /> Edit profile</a>
              </li>
              <li class="nav-item">
                <a class="nav-link py-3 border-top border-light text-black" :class="active_tab == 'history' ? 'active' : ''" @click="active_tab = 'history'"><Icon icon="ri:shopping-cart-line" /> Order history</a>
              </li>
              <li class="nav-item">
                <a class="nav-link py-3 border-top border-light text-black" :class="active_tab == 'password' ? 'active' : ''" @click="active_tab = 'password'"><Icon icon="ri:lock-password-line" /> Change password</a>
              </li>
            </ul>
          </div>
          <div class="col-sm-9">
            <div v-if="active_tab == 'profile'" class="card p-4">
              <b-form @submit.prevent="update_profile">
                <h5 class="section-header mb-3"><Icon icon="ri:book-2-line" /> Account details :</h5>
                <div class="row">
                  <div class="col-sm-6">
                    <w-field SimpleDataType="String" v-model="profile_form.name" Title="Full name :" Required></w-field>
                  </div>
                  <div class="col-sm-6">
                    <w-field SimpleDataType="Phone" v-model="profile_form.phone" Title="Phone number :"></w-field>
                  </div>
                  <div class="col-sm-6">
                    <w-field SimpleDataType="String List, Single" v-model="profile_form.timezone" :Options="timezones" Title="Timezone :"></w-field>
                  </div>
                  <div class="col-sm-6">
                    <w-field SimpleDataType="String List, Single" v-model="profile_form.referred_by" :Options="referral_types" Title="How did you hear about us? :"></w-field>
                  </div>
                  <div class="col-sm-6">
                    <w-field SimpleDataType="String" v-model="profile_form.referred_name" Title="Who referred you? (if referred by another client) :"></w-field>
                  </div>
                </div>
                <h5 class="section-header mb-3 mt-5"><Icon icon="ri:book-2-line" /> Physical address :</h5>
                <div class="row">
                  <div class="col-sm-12">
                    <w-field SimpleDataType="String" v-model="profile_form.Address" Title="Address :"></w-field>
                  </div>
                  <div class="col-sm-4">
                    <w-field SimpleDataType="String" v-model="profile_form.City" Title="City :"></w-field>
                  </div>
                  <div class="col-sm-4">
                    <w-field SimpleDataType="String List, Single" v-model="profile_form.StateOrProvince" :Options="states" Title="State :"></w-field>
                  </div>
                  <div class="col-sm-4">
                    <w-field SimpleDataType="String" v-model="profile_form.PostalCode" Title="Zip code :"></w-field>
                  </div>
                </div>
                <h5 class="section-header mb-3 mt-5"><Icon icon="ri:book-2-line" /> Mailing address :</h5>
                <div class="row">
                  <div class="col-sm-12">
                    <w-field SimpleDataType="String" v-model="profile_form.MailingAddress" Title="Address :"></w-field>
                  </div>
                  <div class="col-sm-4">
                    <w-field SimpleDataType="String" v-model="profile_form.MailingCity" Title="City :"></w-field>
                  </div>
                  <div class="col-sm-4">
                    <w-field SimpleDataType="String List, Single" v-model="profile_form.MailingStateOrProvince" :Options="states" Title="State :"></w-field>
                  </div>
                  <div class="col-sm-4">
                    <w-field SimpleDataType="String" v-model="profile_form.MailingPostalCode" Title="Zip code :"></w-field>
                  </div>
                </div>
                <h5 class="section-header mb-3 mt-5"><Icon icon="ri:book-2-line" /> Billing address :</h5>
                <div class="row">
                  <div class="col-sm-12">
                    <w-field SimpleDataType="String" v-model="profile_form.BillingAddress" Title="Address :"></w-field>
                  </div>
                  <div class="col-sm-4">
                    <w-field SimpleDataType="String" v-model="profile_form.BillingCity" Title="City :"></w-field>
                  </div>
                  <div class="col-sm-4">
                    <w-field SimpleDataType="String List, Single" v-model="profile_form.BillingStateOrProvince" :Options="states" Title="State :"></w-field>
                  </div>
                  <div class="col-sm-4">
                    <w-field SimpleDataType="String" v-model="profile_form.BillingPostalCode" Title="Zip code :"></w-field>
                  </div>
                </div>
                <div class="border-top border-light mt-5 pt-4 text-right">
                  <button type="submit" class="btn btn-success ml-3" :disabled="dsbl_btn"><span v-if="dsbl_btn" class="spinner-border spinner-border-sm"></span><Icon v-else icon="ri:save-line" /> Save changes</button>
                </div>
              </b-form>
            </div>
            <div v-else-if="active_tab == 'history'" class="">
              <div class="mb-4">
                <div class="input-group">
                  <input class="form-control py-2 border-right-0 border-light _h-50" type="search" placeholder="Search for content..." v-model="search">
                  <span class="input-group-append">
                    <div class="input-group-text bg-white border-light"><Icon icon="ri:search-line" class="_f-s-20 mt-0 text-muted" /></div>
                  </span>
                </div>
              </div>

              <transition-group id="accordion" name="fade" class="accordion mt-4 mb-5">
                <div v-if="!loading && !computedResults.length" :key="0" class="card p-3">
                  <div class="card-body p-5 text-center border rounded _b-s-7 _b-dashed border-lght">
                    <h3>No results were found</h3>
                    <p class="m-0">Please adjust your filters</p>
                  </div>
                </div>
                <div v-for="(item, item_i) in computedResults" :key="item.id" class="card">
                  <div :id="'his-'+item.id" class="card-header p-0 mb-0 bg-white border-light">
                    <div class="_c-pointer p-4" data-toggle="collapse" :data-target="'#his-c-'+item.id">
                      <Icon icon="ri:arrow-down-s-line" class="float-right _f-s-30 my-2" />
                      
                      <h4 class="mb-0 py-2 text-black"><Icon icon="ri:road-map-line" class="_f-s-30 mr-2" /> {{ item.Address }} {{ item.City }} {{ item.StateOrProvince }} {{ item.PostalCode }}</h4>
                    </div>
                  </div>
                  <div :id="'his-c-'+item.id" class="collapse" data-parent="#accordion">
                    <div class="card-body border-bottom border-light">
                      <div v-for="(cart, cart_i) in item['carts']" :key="cart_i">
                        <w-invoice :item="cart"></w-invoice>
                      </div>
                    </div>
                  </div>
                </div>
              </transition-group>
              <div class="pt-4">
                <w-pagination :pagination="pagination" @paginate="results=[];fetch_history()" :offset="3" :center="true"></w-pagination>
              </div>
            </div>
            <div v-else-if="active_tab == 'password'" class="card p-4">
              <b-form @submit.prevent="update_password">
                <h5 class="section-header mb-3"><Icon icon="ri:book-2-line" /> Change password :</h5>
                <div class="row">
                  <div class="col-sm-6">
                    <w-field SimpleDataType="Password" v-model="password_form.currentpassword" Title="Current password :" Required></w-field>
                  </div>
                  <div class="col-sm-6">
                    <w-field SimpleDataType="Password" v-model="password_form.newpassword" Title="New password :" Required></w-field>
                  </div>
                  <div class="col-sm-6">
                    <w-field SimpleDataType="Password" v-model="password_form.newpassword_confirmation" Title="Confirm new password :" Required></w-field>
                  </div>
                </div>
                <div class="border-top border-light mt-5 pt-4 text-right">
                  <button type="submit" class="btn btn-success ml-3" :disabled="dsbl_btn"><span v-if="dsbl_btn" class="spinner-border spinner-border-sm"></span><Icon v-else icon="ri:save-line" /> Save changes</button>
                </div>
              </b-form>
            </div>
          </div>
        </div>

        <div v-if="pc['post_btn'] && pc['post_btn'].length" class="text-center">
          <a v-for="(btn, btn_i) in pc['post_btn']" :key="btn_i" v-if="btn['text'] || btn['pre_icon'] || btn['post_icon']" class="btn btn-lg mb-3 mx-3" :class="'btn-'+btn['color']" :href="btn['url']" target="_blank">
            <Icon v-if="btn['pre_icon']" :icon="btn['pre_icon']" height="20"></Icon>
            <span v-if="btn['pre_icon'] && btn['text']" class="border-left mx-3"></span>
            {{ btn['text'] }}
            <span v-if="btn['post_icon'] && btn['text']" class="border-left mx-3"></span>
            <Icon v-if="btn['post_icon']" :icon="btn['post_icon']" height="20"></Icon>
          </a>
        </div>

      </div>
    </div>
  </section>

</template>

<style>

</style>